export default "__VITE_ASSET__CcVz$9qw__"